import { createValidation } from '../../utils/validation';
import manualTypeConfig from './manualTypeConfig';

const createManualTypeValidation = () => createValidation(manualTypeConfig.fields);

export const createManualTypeValidationSchema = createManualTypeValidation;
export default createManualTypeValidation;
